import { MultiService } from 'modules/api/MultiService';
import { RootState } from 'store';
import { TFAQueryFnParams } from 'modules/tfa/types';
import { createQueryFnWithErrorHandler } from 'store/utils/createQueryFnWithErrorHandler';
import { selectAccountAddress } from 'modules/account/store/selectors';
import { web3Api } from 'store/queries';

import { fetchJWTs } from './fetchJWTs';
import { resetSelectedProjectEndpointTokenIfDeleted } from '../store/jwtTokenManagerSlice';

interface DeleteJwtTokenParams {
  tokenIndex: number;
  group?: string;
}

export const {
  endpoints: { deleteJwtToken },
  useDeleteJwtTokenMutation,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    deleteJwtToken: build.mutation<
      null,
      TFAQueryFnParams<DeleteJwtTokenParams>
    >({
      queryFn: createQueryFnWithErrorHandler({
        queryFn: async (
          { params: { group, tokenIndex }, totp },
          { dispatch },
        ) => {
          const service = MultiService.getService().getAccountingGateway();

          await service.deleteJwtToken({ index: tokenIndex, group, totp });

          dispatch(
            fetchJWTs.initiate(
              { group, forceFetchInternal: true },
              { forceRefetch: true },
            ),
          );

          return { data: null };
        },
      }),
      onQueryStarted: async (
        { params: { tokenIndex } },
        { dispatch, getState, queryFulfilled },
      ) => {
        await queryFulfilled;

        const accountAddress = selectAccountAddress(getState() as RootState);

        if (accountAddress) {
          dispatch(
            resetSelectedProjectEndpointTokenIfDeleted({
              address: accountAddress,
              tokenIndex,
            }),
          );
        }
      },
    }),
  }),
});
